import { CommonModule, DatePipe } from '@angular/common';
import { BrowserModule, Meta, BrowserTransferStateModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
//import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'; /* this is not required to use, but for product and customer I have used, for employee created separate module and this is included in that modul */
// import { OwlModule } from 'ngx-owl-carousel';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
//import { IconModule } from '@visurel/iconify-angular';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import {MatRadioModule} from '@angular/material/radio';

// import { SocialLoginModule, SocialAuthServiceConfig } from 'angularx-social-login';
// import { GoogleLoginProvider, FacebookLoginProvider } from 'angularx-social-login';

//import { Observable } from 'rxjs';
import { AngularFireAuthModule } from '@angular/fire/auth';

import { UserService } from './shared/services/user.service';
import { CommonService } from './shared/services/common.service';
import { SEOService } from './shared/services/seo.service';
import { BroadcastService } from './shared/services/broadcast.service';


import { ClickElsewhereDirective } from './shared/directives/click-outside.directive.directive';

import * as $ from 'jquery';
import * as bootstrap from 'bootstrap';


import { ClipboardModule } from 'ngx-clipboard';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/layouts/header/header.component';
import { FooterComponent } from './components/layouts/footer/footer.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { SafePipe } from './shared/pipes/safepipe';
import { NgxSpinnerModule } from "ngx-spinner";
import { LoadingService } from './shared/services/loading.service';
import { globals } from './globals/globals';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAnalyticsModule, ScreenTrackingService } from '@angular/fire/analytics';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { environment } from '../environments/environment';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { SearchComponent } from './components/search/search.component';
import { SearchFilterPipe } from './shared/pipes/search-filter.pipe';
import { SplashScreenComponent } from './components/splash-screen/splash-screen.component';
import { NotSupportedComponent } from './components/not-supported/not-supported.component';
import { PhoneFormatPipe } from './phone-format.pipe';
import { AppInstallButtonComponent } from './components/sharedButton/app-install-button/app-install-button.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { ShortsComponent } from './shorts/shorts.component';
import { MemeBattleComponent } from './meme-battle/meme-battle.component';
// import { InfiniteScrollModule } from "ngx-infinite-scroll";

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    ClickElsewhereDirective,
    SafePipe,
    SearchComponent,
    SearchFilterPipe,
    SplashScreenComponent,
    NotSupportedComponent,
    PhoneFormatPipe,
    AppInstallButtonComponent,
    ChangePasswordComponent,
    ShortsComponent,
    MemeBattleComponent
    // StarringDetailsComponent
  ],
  imports: [
    CommonModule,
    BrowserModule.withServerTransition({ appId: 'app-dangal' }),
    BrowserTransferStateModule,
    // BrowserModule.withServerTransition({ appId: '' }),
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatInputModule,
    MatRadioModule,
    //AngularFontAwesomeModule,
    // OwlModule,
    // MatInputModule,
    MatIconModule,
    MatSnackBarModule,
    MatTooltipModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    ClipboardModule,
    //SocialLoginModule,
    NgxSpinnerModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AngularFireAnalyticsModule,
    AngularFirestoreModule,
    LazyLoadImageModule,
    NgxMatSelectSearchModule,
    // InfiniteScrollModule
   // Observable
  ],
  providers: [Meta, UserService, CommonService, SEOService, BroadcastService, LoadingService, ScreenTrackingService,DatePipe
    // {provide: 'googleTagManagerId', useValue: 'AW-449178627'} 
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
